import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { UserCard } from '@/entities/user/user-card/UserCard'
import type { UserDto } from '@/shared/api/user'
import { useUserItem } from '@/shared/api/user'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute(
  '/_auth/canteen/meal-restrictions/restriction/$restrictionId/common/user/$userId'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  const { isOpen, close } = useRouteOffcanvas('../..')
  const { userId } = Route.useParams()
  const { data, isLoading, isError } = useUserItem({ id: userId })

  // API may return UserDto directly instead of { user: UserDto }
  const user = (data?.user ?? data) as UserDto | undefined

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Карточка пользователя АПК')}>
      <UserCard user={user} isLoading={isLoading} isError={isError} />
    </Offcanvas>
  )
}
